import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { HttpHelperDataService } from './http-helper-data.service';
import { Configuration } from '../../app.configuration.service';
import { SecurityService } from './security.service';
import { Observable } from 'rxjs';

@Injectable()
export class ProfileDataService extends HttpHelperDataService {

    constructor(protected http: HttpClient, protected configuration: Configuration, protected securityService: SecurityService) {
        super(http, configuration, securityService);
        this.controllerName = 'v1/SecurityExtension';
    }

    public changePassword = (password: string, passwordToSave: string): Observable<boolean> => {
        const toSave = JSON.stringify({ guid: '', currentPassword: password, newPassword: passwordToSave });
        return this.httpPost('ChangePasswordFO', toSave);
    }
}
